import { render, staticRenderFns } from "./associated_position.vue?vue&type=template&id=6b88dafe&scoped=true"
import script from "./associated_position.vue?vue&type=script&lang=js"
export * from "./associated_position.vue?vue&type=script&lang=js"
import style0 from "./associated_position.vue?vue&type=style&index=0&id=6b88dafe&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88dafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b88dafe')) {
      api.createRecord('6b88dafe', component.options)
    } else {
      api.reload('6b88dafe', component.options)
    }
    module.hot.accept("./associated_position.vue?vue&type=template&id=6b88dafe&scoped=true", function () {
      api.rerender('6b88dafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/role_manage/form/associated_position/associated_position.vue"
export default component.exports